import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "IrradiationHistoryWidget": {
        meta: {
            i18nDescrKey: 'irradiation-history-tile-label',
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: 'IRRADIATION'
        },
        component: () => import('./components/IrradiationHistoryWidget.vue')
    },
    "IrradiationProvisionalWidget": {
        meta: {
            i18nDescrKey: 'irradiation-provisional-tile-label',
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: 'IRRADIATION'
        },
        component: () => import('./components/IrradiationProvisionalWidget.vue')
    }
};

export default globals;
